/**
 * Base URL de la API — usa el BASE_URL de Vite para derivar el prefijo correcto.
 * En producción (base="/oracle/"): API_BASE = "/oracle/api/ai"
 * En desarrollo (base="/"): API_BASE = "/api/ai"
 */
const base = import.meta.env.BASE_URL.replace(/\/$/, ""); // "/oracle" o ""
export const API_BASE = `${base}/api`;
